import PropTypes from 'prop-types';

import * as c from './constants';

const AddressFieldsMeta = PropTypes.shape({
  type: PropTypes.string,
  field: PropTypes.oneOf([
    c.ADDRESS_FIELD_ADDRESS1,
    c.ADDRESS_FIELD_ADDRESS2,
    c.ADDRESS_FIELD_CITY,
    c.ADDRESS_FIELD_STATE,
    c.ADDRESS_FIELD_ZIP,
  ]),
  label_translation_key: PropTypes.string,
  required: PropTypes.bool,
});

const AgeVerification = PropTypes.shape({
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
  date_of_birth: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  meta: PropTypes.shape({
    address: PropTypes.arrayOf(AddressFieldsMeta),
  }),
  state: PropTypes.string,
  user_info_needed_explanation: PropTypes.string,
  user_step: PropTypes.oneOf([
    c.STEP_DOB_NAME,
    c.STEP_ADDRESS,
    c.STEP_ADDRESS_RETRY,
    c.STEP_ID_PHOTOS,
    c.STEP_ID_PHOTOS_RETRY,
  ]),
  verification_status: PropTypes.oneOf([
    c.STATUS_PENDING_USER_INFO,
    c.STATUS_PENDING_REVIEW,
    c.STATUS_FAILED,
    c.STATUS_VERIFIED,
  ]),
  verified_for_purchase: PropTypes.bool.isRequired,
  verified_for_warranty_replacement: PropTypes.bool.isRequired,
  zip: PropTypes.string,
});

const propTypes = {
  ...PropTypes,
  AgeVerification,
  AddressFieldsMeta,
};

export default propTypes;



// WEBPACK FOOTER //
// ./app/javascript/apps/age_verification/propTypes.js